import { Component, HostBinding, inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KeeniconComponent } from '../../keenicon/keenicon.component';
import { CompanyModel } from '../../../models/company.model';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
@Component({
	selector: 'app-active-company',
	templateUrl: './active-company.component.html',
	imports: [CommonModule, KeeniconComponent, TranslateModule],
	standalone: true,
})
export class ActiveCompanyComponent implements OnInit {
	@HostBinding('class')
	class = `menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-300px`;
	btnClass = 'h-auto btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary ms-3';
	@HostBinding('attr.data-kt-menu') dataKtMenu = 'true';

	@Input() selectedCompany: CompanyModel | null = null;
	private router = inject(Router);
	constructor() {}

	ngOnInit(): void {}

	openEditCompany() {
		this.router.navigate(['/edit-company']);
	}

	openUser() {
		this.router.navigate(['/user-management']);
	}

	openRoles() {
		this.router.navigate(['/roles']);
	}
}
